import styles from './unauthorizedStudentPortal.module.css';

const UnauthorizedStudentPortal = () => {
  return (
    <div className={styles['body-container']}>
      You do not have any courses to evaluate at this time. Please check again later.
    </div>
  );
};

export default UnauthorizedStudentPortal;